import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import { KendoBaseComponent, 
    KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import KendoChartBase from '../KendoChartBase'
import AxisDefaults from '../KendoChartBase/AxisDefaults'
import CategoryAxis from '../KendoChartBase/CategoryAxis'
import ChartArea from '../KendoChartBase/ChartArea'
import Legend from '../KendoChartBase/Legend'
import Panes from '../KendoChartBase/Panes'
import Pannable from '../KendoChartBase/Pannable'
import Pdf from '../KendoChartBase/Pdf'
import PlotArea from '../KendoChartBase/PlotArea'
import Series from '../KendoChartBase/Series'
import SeriesDefaults from '../KendoChartBase/SeriesDefaults'
import Title from '../KendoChartBase/Title'
import Tooltip from '../KendoChartBase/Tooltip'
import ValueAxis from '../KendoChartBase/ValueAxis'
import XAxis from '../KendoChartBase/XAxis'
import YAxis from '../KendoChartBase/YAxis'
import Zoomable from '../KendoChartBase/Zoomable'


export default {
    mixins: [
        KendoChartBase,
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        AxisDefaults,
        CategoryAxis,
        ChartArea,
        Legend,
        Panes,
        Pannable,
        Pdf,
        PlotArea,
        Series,
        SeriesDefaults,
        Title,
        Tooltip,
        ValueAxis,
        XAxis,
        YAxis,
        Zoomable
    ],
    emits: {
        'kendowidgetready': null
    },
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    mounted() {
        kendo.jQuery(this.$el).kendoChart(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChart/KendoChartMixin.js